import React from "react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import Icon from "../../../components/Icon";
import Button from "../../../components/Button.jsx";
import { DialogNewWorkflow } from "../DialogNewWorkflow";

export default function WorkflowEmptyState({
    searchTerm,
    showArchived,
    appId,
    currentApp,
    iconName = "Workflow",
}) {
    const { t } = useTranslation();

    const title = searchTerm
        ? t("workflowIndex.emptyState.noResults", { searchTerm })
        : showArchived
        ? t("workflowIndex.emptyState.noArchived")
        : appId && currentApp
        ? t("workflowIndex.appSpecific.noWorkflowsInApp", {
              appTitle: currentApp.title,
          })
        : t("workflowIndex.emptyState.noAutomations");

    const description = searchTerm
        ? t("workflowIndex.emptyState.noResultsDescription")
        : showArchived
        ? t("workflowIndex.emptyState.noArchivedDescription")
        : appId && currentApp
        ? t("workflowIndex.appSpecific.createFirstWorkflowInApp", {
              appTitle: currentApp.title,
          })
        : t("workflowIndex.emptyState.noAutomationsDescription");

    return (
        <div className="text-center p-8 rounded-lg border-2 border-dashed border-gray-300 bg-white">
            <div className="flex flex-col items-center gap-2">
                <div className="rounded-full bg-gray-50 p-3">
                    <Icon name={iconName} className="h-8 w-8 text-gray-400" />
                </div>
                <h3 className="mt-2 text-sm font-semibold text-gray-900">
                    {title}
                </h3>
                <p className="mt-1 text-sm text-gray-500 max-w-sm">
                    {description}
                </p>
                {!showArchived && (
                    <div className="mt-4">
                        <DialogNewWorkflow appType="AUTOMATION" appId={appId}>
                            <Button
                                className="text-xs sm:text-sm"
                                data-guided="new-workflow"
                            >
                                <Plus className="mr-1 sm:mr-2 h-3 w-3 sm:h-4 sm:w-4" />
                                {t("workflowIndex.newAutomationOrApp")}
                            </Button>
                        </DialogNewWorkflow>
                    </div>
                )}
            </div>
        </div>
    );
}
